import { Table, TableColumn, TableCellProps } from '@servicetitan/table';
import { observer } from 'mobx-react';
import { FC, useRef, Fragment } from 'react';

import { Button, Form, Modal, Radio, Stack, Spinner } from '@servicetitan/design-system';
import { useDependencies } from '@servicetitan/react-ioc';

import { AvailableNumberModel } from '@servicetitan/application-data/telecom';
import { PhoneNumbersStore } from '../../stores/phone-numbers.store';

export const NumberSelect: FC = observer(() => {
    const [store] = useDependencies(PhoneNumbersStore);
    const gridRef = useRef<Table<AvailableNumberModel>>(null);
    const { phoneNumber } = store.formState.$.editFormState.$;
    const onLoadMore = async () => {
        await store.loadMoreNumbers();
        gridRef.current!.scrollToBottom();
    };

    return (
        <Fragment>
            <Modal.Header title="Search Results" onClose={store.closeModal} />
            <Modal.Content>
                <Form className="m-t-1-i m-b-0-i">
                    {!store.searchInProgress && (
                        <Table
                            ref={gridRef}
                            tableState={store.availableNumbersGridsState}
                            style={{ height: 290 }}
                            rowHeight={50}
                            striped={false}
                        >
                            <TableColumn
                                title="PhoneNumber"
                                field="friendlyName"
                                cell={AvailablePhoneNumberCell}
                                headerClassName="p-l-3-i"
                            />
                            <TableColumn title="State" field="state" width={150} />
                        </Table>
                    )}
                    <Stack justifyContent="space-around" className="m-t-2">
                        {store.searchInProgress ? (
                            <Spinner />
                        ) : (
                            !!store.availableNumbersGridsState.totalCount && (
                                <Button
                                    width="123px"
                                    onClick={onLoadMore}
                                    disabled={!store.canAddMoreNumbers}
                                >
                                    Load More
                                </Button>
                            )
                        )}
                    </Stack>
                </Form>
            </Modal.Content>
            <Modal.Footer align="space-between">
                <Button onClick={store.goBack}>Back</Button>
                <Button primary onClick={store.goForward} disabled={!phoneNumber.value}>
                    Choose Number
                </Button>
            </Modal.Footer>
        </Fragment>
    );
});

export const AvailablePhoneNumberCell = observer((props: TableCellProps) => {
    const [store] = useDependencies(PhoneNumbersStore);
    const { phoneNumber, friendlyName } = store.formState.$.editFormState.$;
    const data = props.dataItem as AvailableNumberModel;
    const onChange = (value: string) => {
        phoneNumber.onChange(value);
        friendlyName.onChange(data.friendlyName);
    };

    return (
        <td>
            <Radio
                onChange={onChange}
                size="small"
                className="m-l-1"
                label={data.friendlyName}
                value={data.phoneNumber}
                checked={data.phoneNumber === phoneNumber.value}
            />
        </td>
    );
});
